import React, { memo } from "react";
import { useSelector } from "react-redux";
import ReactPlayer from "react-player";
import PropTypes from "prop-types";
import DicomViewer from "../DicomViewer";
import messages from "../../assets/locale/messages";
import styles from "./MaterialPreview.module.scss";
import { getSupplementaryTypeLabel } from "../../utils/Helpers";
import { ImgDisplay } from "../../hooks/ImgDisplay";
import {
  getFullCloudFrontURL,
  getFullPublicURL
} from "../../utils/Constants";

const MaterialPreview = ({
  src,
  type,
  isPublic = false,
  wrapperWidth,
  wrapperHeight,
  dicomImages,
  className,
  hasClear,
  onClear,
  style
}) => {
  const lang = useSelector((state) => state.locale.lang);

  const { shared } = messages[lang];

  const renderPreview = () => {
    const urlSrc = src
      ? src?.startsWith("blob")
        ? src
        : isPublic
        ? getFullPublicURL(src)
        : getFullCloudFrontURL(src)
      : "";

    switch (type) {
      case 0: //video
        return (
          <ReactPlayer
            className={styles.preview}
            url={urlSrc}
            width="100%"
            height="100%"
            controls={true}
          />
        );
      case 1: //image
        return (
          <ImgDisplay
            style={style}
            src={urlSrc}
            className={`${styles.preview} ${className}`}
            hasClear={hasClear}
            onClear={onClear}
          />
        );
      case 2: //dicom
        return (
          <DicomViewer
            imageIds={dicomImages}
            className={`${styles.PreviewDICOM}`}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={`${styles.wrapper} ${
        type === 2 ? styles.WrapperDICOM : ""
      }`}
      style={{
        width: `${wrapperWidth ? wrapperWidth : null}`,
        height: `${wrapperHeight ? wrapperHeight : null}`
      }}
    >
      {!src && (
        <div
          style={{ height: "25vh" }}
          className={`${styles.emptyPreview} d-flex align-items-center justify-content-center fsize-20`}
        >
          {shared[`${getSupplementaryTypeLabel(type).label}Preview`]}
        </div>
      )}
      {renderPreview()}
    </div>
  );
};

MaterialPreview.propTypes = {
  isPublic: PropTypes.bool.isRequired,
  wrapperWidth: PropTypes.number.isRequired,
  wrapperHeight: PropTypes.number.isRequired,
  src: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.number.isRequired,
  dicomImages: PropTypes.arrayOf(PropTypes.string),
  hasClear: PropTypes.bool,
  onClear: PropTypes.func,
  style: PropTypes.object
};

MaterialPreview.defaultProps = {
  src: "",
  className: "",
  type: 0,
  dicomImages: [],
  hasClear: false
};

export default memo(MaterialPreview);
